

export const index = 2;
export const component = async () => (await import('../entries/pages/_page.svelte.js')).default;
export const file = '_app/immutable/components/pages/_page.svelte-03790eb2.js';
export const imports = ["_app/immutable/components/pages/_page.svelte-03790eb2.js","_app/immutable/chunks/index-ae03fd13.js"];
export const stylesheets = [];
export const fonts = [];
